import { useEffect, useRef } from 'react';

const WS_URL = process.env.REACT_APP_BACKEND_URL.replace('https://', 'wss://').replace('http://', 'ws://');

// Rafraichit les donnees en temps reel : refetch (debounce 1.2s) a chaque modification cote serveur.
export default function useLiveRefresh(onChange) {
    const cbRef = useRef(onChange);
    cbRef.current = onChange;

    useEffect(() => {
        let ws, retryTimer, debounceTimer, closed = false;
        const connect = () => {
            if (closed) return;
            try {
                ws = new WebSocket(`${WS_URL}/api/ws/live-${Math.random().toString(36).slice(2)}`);
                ws.onmessage = () => {
                    clearTimeout(debounceTimer);
                    debounceTimer = setTimeout(() => cbRef.current(), 1200);
                };
                ws.onclose = () => { if (!closed) retryTimer = setTimeout(connect, 5000); };
                ws.onerror = () => ws.close();
            } catch {
                retryTimer = setTimeout(connect, 5000);
            }
        };
        connect();
        return () => {
            closed = true;
            clearTimeout(retryTimer);
            clearTimeout(debounceTimer);
            if (ws) { ws.onclose = null; ws.close(); }
        };
    }, []);
}
